module.exports = __webpack_public_path__ + "static/media/clock.68cab6f5.svg";